import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { FlashMessageService } from 'src/app/shared/services/flash-message.service';
import { RequestAccessTypesEnum } from 'src/app/shared/enum/request-access-types.enum';
import { CustomerService } from 'src/app/services/customer/customer.service';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics/google-analytics.service';
import { BusinessUnitEnum } from 'src/app/shared/enum/business-unit.enum';
import * as _ from 'lodash';
import { RegexEnum } from 'src/app/core/enum/regex.enum';

@Component({
  selector: 'request-access',
  templateUrl: './request-access.component.html',
  styleUrls: ['./request-access.component.scss']
})
export class RequestAccessComponent implements OnInit {

  public loading: boolean = false;
  public phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  public raTypes = RequestAccessTypesEnum;
  public businessUnitEnum = BusinessUnitEnum;
  public keepOriginalOrder = (a, b) => a.key;
  public regexEnum = RegexEnum;

  constructor(
    public customerService: CustomerService,
    private _gaSvc: GoogleAnalyticsService,
    private flashMessageService: FlashMessageService,
    private location: Location) { }

  ngOnInit() {
    this.customerService.newCustomerUserRequest = {};
    this.customerService.newCustomerUserRequest.requestType = this.raTypes.CUSTOMER;
    this._gaSvc.register('Request Access', 'User viewed request access page');
  }

  public back() {
    this.location.back();
  }

  onSubmit() {
    this.loading = true;

    if (this.customerService.newCustomerUserRequest.requestType === this.raTypes.CARRIER) {
      if (!this.customerService.newCustomerUserRequest.businessUnit.includes('LGS')) {
        this.customerService.newCustomerUserRequest.transportMode = 'TL';
      }
    } else {
      this.customerService.newCustomerUserRequest = _.omit(this.customerService.newCustomerUserRequest, ['businessUnit', 'transportMode']);
    }

    if (
      this.customerService.newCustomerUserRequest.requestType === this.raTypes.CARRIER ||
      this.customerService.newCustomerUserRequest.requestType === this.raTypes.FACTORING_COMPANY
    ) {
      this.customerService.createCarrierRequest()
        .then(async (response) => {
          this._gaSvc.register( `Request Access`, `User submitted request access`);
          this.customerService.resetCustomerUser();
          await this.flashMessageService.updateMessage("Successfully created a request.", 5000, "success");
          window.location.href = window.location.origin;
        }).catch((error) => {
          this.loading = false;
          this.flashMessageService.updateMessage("There was a problem creating your request.", 5000, "danger");
        });
    } else {
      this.customerService.createCustomerRequest()
        .then(async (response) => {
          this.customerService.resetCustomerUser();
          this._gaSvc.register('Request Access', 'User submitted access request');
          await this.flashMessageService.updateMessage("Successfully created a request.", 5000, "success");
          window.location.href = window.location.origin;
        }).catch((error) => {
          this.loading = false;
          this.flashMessageService.updateMessage("There was a problem creating your request.", 5000, "danger");
        });
    }

  }

  public onRATypeChecked(type: string) {
    this.customerService.newCustomerUserRequest.requestType = type;
  }

}

